const Panel_Z02_development_configurations = () => null;

export default Panel_Z02_development_configurations;
